import Vue from 'vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Calendar from 'vux/src/components/calendar/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XProgress from 'vux/src/components/x-progress/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Range from 'vux/src/components/range/index.vue'


import AppFooter from '@/components/Footer'
import AppHeader from '@/components/Header'

Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX'
})
Vue.use(AjaxPlugin)
Vue.use(AlertPlugin)
Vue.use(DatetimePlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.directive('transfer-dom', TransferDom)
Vue.component('actionsheet', Actionsheet)
Vue.component('alert', Alert)
Vue.component('badge', Badge)
Vue.component('blur', Blur)
Vue.component('box', Box)
Vue.component('button-tab', ButtonTab)
Vue.component('button-tab-item', ButtonTabItem)
Vue.component('calendar', Calendar)
Vue.component('card', Card)
Vue.component('cell', Cell)
Vue.component('divider', Divider)
Vue.component('cell-box', CellBox)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('datetime', Datetime)
Vue.component('checklist', Checklist)
Vue.component('range', Range)
Vue.component('flexbox', Flexbox)
Vue.component('previewer', Previewer)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('form-preview', FormPreview)
Vue.component('grid', Grid)
Vue.component('grid-item', GridItem)
Vue.component('group', Group)
Vue.component('group-title', GroupTitle)
Vue.component('loading', Loading)
Vue.component('msg', Msg)
Vue.component('panel', Panel)
Vue.component('popup', Popup)
Vue.component('search', Search)
Vue.component('selector', Selector)
Vue.component('scroller', Scroller)
Vue.component('step', Step)
Vue.component('icon', Icon)
Vue.component('confirm', Confirm)
Vue.component('step-item', StepItem)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('inline-loading', InlineLoading)
Vue.component('inline-x-number', InlineXNumber)
Vue.component('inline-x-switch', InlineXSwitch)
Vue.component('tab', Tab)
Vue.component('popup-header', PopupHeader)
Vue.component('tab-item', TabItem)
Vue.component('sticky', Sticky)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('timeline', Timeline)
Vue.component('timeline-item', TimelineItem)
Vue.component('x-address', XAddress)
Vue.component('x-button', XButton)
Vue.component('x-dialog', XDialog)
Vue.component('x-header', XHeader)
Vue.component('x-input', XInput)
Vue.component('radio', Radio)
Vue.component('x-number', XNumber)
Vue.component('x-switch', XSwitch)
Vue.component('x-textarea', XTextarea)
Vue.component('popover', Popover)
Vue.component('x-table', XTable)
Vue.component('view-box', ViewBox)
Vue.component('x-progress', XProgress)

Vue.component('app-header', AppHeader)
Vue.component('app-footer', AppFooter)



// WEBPACK FOOTER //
// ./src/vux_import.js